import { BaseStoreRepository } from '../base-store.repository';
import { select } from '@ngneat/elf';
import { BidderStateProps, BidderStore, bidderInitialState } from './bidder-state.store';

export class BidderRepository extends BaseStoreRepository<BidderStateProps> {
  constructor(store: BidderStore) {
    super(store.pipe(select(state => state)), store, bidderInitialState);
  }
}

export class BidderRepositoryFactory {
  static create(store: BidderStore): BidderRepository {
    return new BidderRepository(store);
  }
}
